import { StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

export const inputStyle = StyleSheet.create({
    inputIcon: {
        marginTop: isWeb ? 16 : 14
    },
    nativeInput: {
        height: isWeb ? 52 : 48,
        fontSize: isWeb ? 15 : 14,
    },
    measurementInput: {
        height: isWeb ? 44 : 40,
        fontSize: isWeb ? 15 : 14,
    }
})